module.exports = __webpack_public_path__ + "img/sparkarena-img.04473d76.jpg";